export default __webpack_public_path__ + "static/media/ALINA_HUZ--black.b9ac03d4.svg";